import Router from '../Router';
import { StreakController } from '../../controllers';

export default class StreakRouter extends Router {
	initialize(options) {
		this.typeMenu = 'streak';
		this.controller = new StreakController(options);
	}

	get appRoutes() {
		return {
			'streak': 'streak'
		};
	}
}